import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles((theme) => ({
  tooltip: {
    zIndex: zIndexes.modalZIndex + 1,
  },
  activeOption: {
    color: theme.palette.blue.dark,
  },
  button: {
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    boxShadow: `4px 4px 4px 0px ${theme.palette.boxShadow.default} !important`,
    "& div": {
      padding: "0px !important",
    },
  },
}));

export const styles = {
  removeBtn: {
    width: "133px",
  },
  cancelBtn: {
    width: "127px",
  },
  dialogContent: {
    padding: "20px !important",
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    gap: "40px",
    paddingTop: 0,
  },
  radioGroup: {
    marginTop: "10px",
  },
};
